import {Filters} from 'src/modules/change-requests/typedefs';
import {RootState} from 'src/store/store';

export const getChangeRequestsFilters = (state: RootState): Filters => state.changeRequestsFilters.data;
